<div class="card" *ngIf="data && data?.events?.length > 0">
    <div class="card-body container-fluid container-fluid-5">
      <div class="row row5 mt-2">
        <div class="col-12">
          
          <div class="table-responsive market_analysis mb-2" *ngFor="let eItem of data?.events;trackBy:trackByIndex;">
            
            <div class="match-title game-heading mb-2" (click)="close();" [routerLink]="['/game-detail', eItem?.event_id]">
              <span class="match-name card-header-title">{{eItem.event_name}}</span>
                <button type="button" class="btn-sm btn-back">
                  <i class="fa fa-angle-double-right"></i>
                </button>
            </div>

            <table role="table" aria-busy="false" aria-colcount="8" class="table b-table table-bordered" *ngFor="let mItem of eItem?.data;trackBy:trackByIndex;">
              <thead role="rowgroup" class="">
                <tr role="row" class="">
                    <th colspan="2">{{mItem?.market_type_id.replace('_',' ')}}</th>
                </tr>
              </thead>
              <tbody role="rowgroup" *ngIf="data">
                <tr *ngFor="let item of mItem?.market_data;trackBy:trackByIndex;">
                    <td>{{item?.market_type_id == "FANCY" ? item?.fancy_name : item?.market_type_id == "BOOK_MAKER" ? item?.bookmaker_runner_name : item?.runner_name }}</td>
                    <td [ngClass]="{'text-green' : item?.expose > 0, 'text-red' : item?.expose < 0}"> {{item?.expose}} </td>
                </tr>
              </tbody>
            </table>
          
          </div>

        </div>
      </div>
    </div>
  </div>

  <div class="card" *ngIf="data?.events?.length == 0">
    <div class="card-body container-fluid container-fluid-5">
      <div class="table-responsive no-data">
        <h3>There are currently no followed multi markets.</h3>
        <p>Please add some markets from events.</p>
      </div>
    </div>
  </div>
  

  <app-loader *ngIf="!data" [isFpLoader]="false"></app-loader>